module.exports = __webpack_public_path__ + "img/zhwy_image.0c0f3598.png";